export const LANGUAGES = {
  en: {
    name: "English",
    flag: "🇺🇸",
    code: "en",
  },
  de: {
    name: "Deutsch",
    flag: "🇩🇪",
    code: "de",
  },
  es: {
    name: "Español",
    flag: "🇪🇸",
    code: "es",
  },
  fr: {
    name: "Français",
    flag: "🇫🇷",
    code: "fr",
  },
  it: {
    name: "Italiano",
    flag: "🇮🇹",
    code: "it",
  },
} as const;

export type LanguageCode = keyof typeof LANGUAGES;
